(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dw-discovery-script"] && !Shopify.designMode) return;
  try {
    (()=>{
const DEFAULT_SYNONYMS = `rook = rokerig, rokerige, rokerigs, rook, peated, peat, turf, turfrook, rookinvloed, geturfd, geturfde, smoky
lichte rook = licht rokerig, licht rokerigs, lichte rook, subtiele rook, lichte turf, licht geturfd, lightly peated, mild peated
zacht = zacht, zachte, mild, rond, ronde, toegankelijk, soepel
fruitig = fruitig, fruitige, fruitigs, fruit | cranberry, aardbei, citrus, rood fruit, appel, peer
rood fruit = rood fruit, rode vruchten, rode bessen | cranberry, aardbei, framboos, kers
cranberry = cranberry, cranberries, veenbes, veenbessen
citroen = citroen, citroenen, lemon
citrus = citrus | citroen, sinaasappel, grapefruit, limoen
sherry = sherry | oloroso, px, pedro ximenez
px = px, pedro ximenez
cadeau = cadeau, geschenk, relatiegeschenk, gift, kado
terschelling = terschelling, schylge, terschellinger
eiland = eiland, eilanden | terschelling, schylge
whisky = whisky, whiskey
likeur = likeur, likeuren, liqueur, liquor
kruidig = kruidig, kruidige, kruidigs, kruiden, spicy
vanille = vanille, vanilla
limited = limited, gelimiteerd, beperkte oplage, kleine oplage
special = special, specials, bijzonder, bijzondere, bijzonderheden
zoet = zoet, zoete, sweet, zoetheid`;

const STOP = new Set('ik zoek zoeken een de het met van voor iets graag die wat om en naar wil willen heb hebben heeft op mij mijn jouw je kan is te nog zou houden hou ben zijn in aan als deze dit bij rond ongeveer euro eur onder tot tussen zonder geen niet'.split(' '));
const LEMMAS = {zachte:'zacht',zachts:'zacht',fruitige:'fruitig',fruitigs:'fruitig',rokerige:'rokerig',rokerigs:'rokerig',lichte:'licht',lichts:'licht',zware:'zwaar',sterke:'sterk',stevige:'stevig',heftige:'heftig',zoete:'zoet',donkere:'donker',kruidige:'kruidig',kruidigs:'kruidig',gerijpte:'gerijpt',rode:'rood',ronde:'rond',bijzondere:'bijzonder',whiskey:'whisky',likeuren:'likeur'};
const WEIGHTS = {brand:10,type:9,title:8,tasting:7,tags:7,maturation:6,origin:5,collections:4,description:3};
const NEGATORS = new Set(['zonder','geen','niet','non']);
const HEAVY = new Set(['zwaar','sterk','stevig','heftig','intens','overheersend','veel']);
const BOUNDARIES = new Set(['en','met','maar','of','wel','voor','tot','rond','tussen','onder','van','die']);
const AMOUNT = '(?:\\d{1,3}(?:[. ]\\d{3})+|\\d+)(?:[,.]\\d{1,2})?';

function normalize(value) {
  return String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[’']/g,'').replace(/[^\p{L}\p{N}]+/gu,' ').trim().replace(/\s+/g,' ');
}

function words(value) {
  return normalize(value).split(' ').filter(Boolean).map(word => LEMMAS[word] || word);
}

function numberCents(value) {
  let cleaned = value.replace(/\s/g,'');
  if (cleaned.includes(',')) cleaned = cleaned.replace(/\./g,'').replace(',','.');
  else if (/^\d{1,3}(\.\d{3})+$/.test(cleaned)) cleaned = cleaned.replace(/\./g,'');
  const amount = Math.round(Number(cleaned) * 100);
  return Number.isFinite(amount) && amount >= 0 && amount <= 10000000 ? amount : null;
}

function parseBudget(input) {
  const patterns = [
    ['range',new RegExp('\\btussen\\s*€?\\s*('+AMOUNT+')\\s*(?:en|tot|[-–])\\s*€?\\s*('+AMOUNT+')(?:\\s*(?:euro|eur))?','i')],
    ['around',new RegExp('\\b(?:rond|ongeveer|circa|ca\\.?)\\s*€?\\s*('+AMOUNT+')(?:\\s*(?:euro|eur))?','i')],
    ['under',new RegExp('\\b(?:onder|minder dan)\\s*(?:de\\s*)?€?\\s*('+AMOUNT+')(?:\\s*(?:euro|eur))?','i')],
    ['max',new RegExp('\\b(?:tot(?: en met)?|max(?:imaal)?|hoogstens)\\s*(?:de\\s*)?€?\\s*('+AMOUNT+')(?:\\s*(?:euro|eur))?','i')],
    ['around',new RegExp('€\\s*('+AMOUNT+')','i')],
    ['around',new RegExp('('+AMOUNT+')\\s*(?:euro|eur)\\b','i')]
  ];
  for (const [kind,pattern] of patterns) {
    const match = String(input).match(pattern);
    if (!match) continue;
    const a = numberCents(match[1]);
    const b = match[2] ? numberCents(match[2]) : a;
    if (a === null || b === null) continue;
    let min = 0, max = a;
    if (kind === 'range') { min = Math.min(a,b); max = Math.max(a,b); }
    if (kind === 'around') { min = Math.round(a * .8); max = Math.round(a * 1.2); }
    if (kind === 'under') max = a - 1;
    return {text:String(input).replace(match[0],' '),budget:{min,max,kind,target:a}};
  }
  return {text:String(input),budget:null};
}

function separateNegations(value) {
  const tokens = words(String(value || '').replace(/\b(?:unpeated|non[ -]?peated|niet[ -]?geturfd)\b/gi,'zonder rook'));
  const positive = [], negative = [];
  for (let i=0;i<tokens.length;i++) {
    if (!NEGATORS.has(tokens[i])) { positive.push(tokens[i]); continue; }
    const phrase = [];
    let j=i+1;
    for (; j<tokens.length && phrase.length<4; j++) {
      const token = tokens[j];
      if (BOUNDARIES.has(token) || NEGATORS.has(token)) break;
      if (['een','de','het'].includes(token)) continue;
      phrase.push(token);
      if (!HEAVY.has(token) && !['te','licht','zacht','rood','pedro'].includes(token)) {j++;break;}
    }
    if (phrase.length) negative.push(phrase.join(' '));
    i = Math.max(i,j-1);
  }
  return {positive:positive.join(' '),negative};
}

function parseSynonyms(text) {
  const groups = [], alias = new Map();
  for (const line of String(text || DEFAULT_SYNONYMS).split('\n').slice(0,100)) {
    const at=line.indexOf('=');
    if(at<1) continue;
    const key=words(line.slice(0,at)).join(' ');
    const [same='',related='']=line.slice(at+1).split('|');
    const clean=list=>list.split(',').map(x=>words(x).join(' ')).filter(Boolean);
    const group={key,same:[...new Set([key,...clean(same)])],related:clean(related)};
    groups.push(group);
    for(const term of group.same) if(!alias.has(term)) alias.set(term,group);
  }
  return {groups,alias};
}

function conceptFor(term,synonyms) {
  const group=synonyms.alias.get(term);
  return group ? {key:group.key,forms:[...group.same.map(value=>({value,quality:value===term?1:.92})),...group.related.map(value=>({value,quality:.6}))]} : {key:term,forms:[{value:term,quality:1}]};
}

function conceptsFor(tokens,synonyms) {
  const found=[];
  for(let i=0;i<tokens.length;i++) {
    if(STOP.has(tokens[i])) continue;
    let phrase=tokens[i], size=1;
    for(let n=Math.min(4,tokens.length-i);n>1;n--) {
      const candidate=tokens.slice(i,i+n).join(' ');
      if(synonyms.alias.has(candidate)) { phrase=candidate;size=n;break; }
    }
    found.push(conceptFor(phrase,synonyms));i+=size-1;
  }
  return [...new Map(found.map(x=>[x.key,x])).values()].slice(0,12);
}

function editWithin(a,b,max) {
  if(Math.abs(a.length-b.length)>max || a[0]!==b[0]) return false;
  let previous=Array.from({length:b.length+1},(_,i)=>i), earlier=previous;
  for(let i=1;i<=a.length;i++) {
    const current=[i];let lowest=i;
    for(let j=1;j<=b.length;j++) {
      let distance=Math.min(current[j-1]+1,previous[j]+1,previous[j-1]+(a[i-1]===b[j-1]?0:1));
      if(i>1&&j>1&&a[i-1]===b[j-2]&&a[i-2]===b[j-1]) distance=Math.min(distance,earlier[j-2]+1);
      current[j]=distance;lowest=Math.min(lowest,distance);
    }
    if(lowest>max) return false;
    earlier=previous;previous=current;
  }
  return previous[b.length]<=max;
}

function containsPhrase(text,phrase) {
  return (' '+text+' ').includes(' '+phrase+' ');
}

function matchConcept(field,concept,allowApproximate=true) {
  let best=0;
  for(const form of concept.forms) {
    if(containsPhrase(field.text,form.value)) best=Math.max(best,form.quality);
    if(best===1) return best;
    if(!allowApproximate||form.value.includes(' ')) continue;
    for(const word of field.words) {
      if(form.value.length>=2 && word.startsWith(form.value) && word!==form.value) best=Math.max(best,form.quality*.55);
      else if(form.value.length>=5 && Math.abs(word.length-form.value.length)<=1 && editWithin(form.value,word,1)) best=Math.max(best,form.quality*.38);
    }
  }
  return best;
}

function compileRecord(record) {
  const fields={};
  for(const name of Object.keys(WEIGHTS)) {
    const {positive,negative}=separateNegations(record[name]);
    fields[name]={text:positive,words:new Set(positive.split(' ').filter(Boolean)),negative};
  }
  return {...record,fields,available:record.available===true,prices:(record.prices||[]).map(Number).filter(Number.isFinite),bestRank:Number.isFinite(record.bestRank)?record.bestRank:null};
}

function heavyTrait(record,concept) {
  const heavyWords=[...HEAVY,'te'];
  for(const field of Object.values(record.fields)) {
    const tokens=field.text.split(' ');
    for(const form of concept.forms) {
      if(form.value.includes(' ')) continue;
      for(let i=0;i<tokens.length;i++) {
        if(tokens[i]!==form.value) continue;
        if(tokens.slice(Math.max(0,i-2),i+3).some(x=>heavyWords.includes(x))) return true;
      }
    }
  }
  return false;
}

function createEngine(options={}) {
  const synonyms=parseSynonyms(options.synonyms);
  let records=[], version=0;
  const cache=new Map();
  const ownBrands=(options.ownBrands||'Saint Brandarius,Vierboet,Doriens,Harbor Cask').split(',').map(x=>words(x).join(' ')).filter(Boolean);
  const featured=new Map((options.featuredIds||[]).map((id,i)=>[String(id),i]));

  function setRecords(input) {
    const seen=new Set();
    records=input.filter(record=>{
      if(!record||!record.id||seen.has(String(record.id))) return false;
      if(options.contextKey && String(record.contextKey)!==String(options.contextKey)) return false;
      seen.add(String(record.id));return true;
    }).map(compileRecord);
    version++;cache.clear();
  }

  function parse(input) {
    const {text,budget}=parseBudget(String(input||'').slice(0,200));
    const split=separateNegations(text);
    let positive=conceptsFor(split.positive.split(' '),synonyms);
    const contextKeys=new Set(conceptsFor(words(options.contextTerms),synonyms).map(x=>x.key));
    if(positive.some(x=>!contextKeys.has(x.key))) positive=positive.filter(x=>!contextKeys.has(x.key));
    const negative=split.negative.map(phrase=>{
      const tokens=words(phrase);const heavy=tokens.some(x=>HEAVY.has(x)||x==='te');
      const simple=tokens.filter(x=>!HEAVY.has(x)&&x!=='te'&&!STOP.has(x));
      return {concept:conceptFor(simple.join(' '),synonyms),heavy};
    }).filter(x=>x.concept.key);
    return {positive,negative,budget,normalized:normalize(input),hasQuery:normalize(input).length>=2};
  }

  function filterChip(record,chip) {
    if(chip.mode==='newest'||chip.mode==='best') return true;
    if(chip.mode==='own') return ownBrands.some(brand=>containsPhrase(record.fields.brand.text,brand)||containsPhrase(record.fields.title.text,brand));
    const targets=chip.field==='brand'?['brand','title']:(chip.field==='collections'?['collections','title','tags']:['title','type','tags']);
    return String(chip.terms||'').split(',').map(x=>words(x).join(' ')).filter(Boolean).some(term=>targets.some(name=>containsPhrase(record.fields[name].text,term)));
  }

  function allowed(record,query,chips) {
    if(options.availableOnly!==false&&!record.available) return false;
    if(query.budget&&!record.prices.some(price=>price>=query.budget.min&&price<=query.budget.max)) return false;
    for(const negative of query.negative) {
      if(negative.heavy ? heavyTrait(record,negative.concept) : Object.values(record.fields).some(field=>matchConcept(field,negative.concept,false)>.7)) return false;
    }
    return chips.every(chip=>filterChip(record,chip));
  }

  function score(record,query) {
    let total=0,matches=0;
    for(const concept of query.positive) {
      let strongest=0;
      for(const [name,weight] of Object.entries(WEIGHTS)) strongest=Math.max(strongest,weight*matchConcept(record.fields[name],concept));
      if(strongest>0) { matches++;total+=strongest; }
    }
    total+=matches>1?(matches-1)*5:0;
    if(query.positive.length>1&&matches===query.positive.length) total+=10;
    return {total,matches};
  }

  function search(input='',chips=[],limit=8) {
    const cacheKey=JSON.stringify([version,input,chips,limit]);
    if(cache.has(cacheKey)) return cache.get(cacheKey);
    const query=parse(input);
    if(!query.hasQuery) {query.positive=[];query.negative=[];query.budget=null;}
    const candidates=records.filter(record=>allowed(record,query,chips)).map(record=>({record,...score(record,query)}));
    const mode=chips.find(chip=>chip.mode==='newest'||chip.mode==='best')?.mode;
    const sort=(a,b)=>{
      if(query.positive.length&&b.total!==a.total) return b.total-a.total;
      if(a.record.available!==b.record.available) return a.record.available?-1:1;
      if(mode==='newest') return Number(b.record.created||0)-Number(a.record.created||0)||String(a.record.id).localeCompare(String(b.record.id));
      if(mode==='best') return (a.record.bestRank??1e9)-(b.record.bestRank??1e9)||String(a.record.id).localeCompare(String(b.record.id));
      return (featured.get(String(a.record.id))??1e9)-(featured.get(String(b.record.id))??1e9)||(a.record.bestRank??1e9)-(b.record.bestRank??1e9)||Number(b.record.created||0)-Number(a.record.created||0);
    };
    candidates.sort(sort);
    const matching=query.positive.length?candidates.filter(x=>x.matches>0):candidates;
    const allMatched=matching.some(x=>x.matches===query.positive.length);
    let kind=!query.hasQuery&&!chips.length?'featured':(matching.length?(allMatched?'matches':'partial'):'empty');
    let selected=matching;
    if(!matching.length&&candidates.length&&query.positive.length) {selected=candidates;kind='suggestions';}
    const result={items:selected.slice(0,Math.max(1,Math.min(12,limit))).map(x=>{
      if(!query.budget) return x.record;
      const budget=query.budget,target=budget.kind==='range'?(budget.min+budget.max)/2:budget.target;
      const index=x.record.prices.map((price,i)=>({price,i})).filter(x=>x.price>=budget.min&&x.price<=budget.max).sort((a,b)=>Math.abs(a.price-target)-Math.abs(b.price-target))[0]?.i;
      return {...x.record,matchedOffer:index===undefined?null:{price:x.record.prices[index],id:x.record.variantIds?.[index],label:x.record.variantLabels?.[index]}};
    }),count:matching.length,kind,query,hasBestRank:records.some(x=>x.bestRank!==null)};
    cache.set(cacheKey,result);if(cache.size>40)cache.delete(cache.keys().next().value);
    return result;
  }
  return {setRecords,search,parse,size:()=>records.length};
}
const discoveryMemory = new Map();
const DISCOVERY_VERSION = 'dw-discovery-1';

class DrankwereldDiscovery extends HTMLElement {
  connectedCallback() {
    this.onReady=()=>this.mount();
    if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',this.onReady,{once:true});
    else this.mount();
  }

  mount() {
    if(this.mounted) return;
    const configElement=this.querySelector('[data-dw-config]');
    const seedElement=this.querySelector('[data-dw-seed]');
    if(!configElement||!seedElement) return;
    try {this.config=JSON.parse(configElement.textContent);this.seed=JSON.parse(seedElement.textContent);} catch {return;}
    this.mounted=true;
    this.i18n=this.config.i18n;
    this.input=this.querySelector('[data-dw-input]');
    this.list=this.querySelector('[data-dw-results]');
    this.template=this.querySelector('[data-dw-card-template]');
    this.status=this.querySelector('[data-dw-status]');
    this.message=this.querySelector('[data-dw-message]');
    this.resultTitle=this.querySelector('[data-dw-result-title]');
    this.reset=this.querySelector('[data-dw-reset]');
    this.retry=this.querySelector('[data-dw-retry]');
    this.budgetLabel=this.querySelector('[data-dw-budget]');
    this.chipButtons=[...this.querySelectorAll('[data-dw-chip]')];
    this.active=new Set();this.query='';this.composing=false;this.more=false;this.complete=this.config.source==='selection';
    this.records=new Map(this.seed.map(record=>[String(record.id),{...record,contextKey:this.config.contextKey}]));
    this.engine=createEngine({synonyms:this.config.synonyms,ownBrands:this.config.ownBrands,featuredIds:this.config.featuredIds,contextKey:this.config.contextKey,contextTerms:this.config.contextTerms,availableOnly:this.config.availableOnly});
    this.money=new Intl.NumberFormat(this.config.locale||'nl-NL',{style:'currency',currency:this.config.currency||'EUR'});
    this.cacheKey=[DISCOVERY_VERSION,this.config.themeId,this.config.contextKey,this.config.locale,this.config.country,this.config.currency].join(':');
    this.nextPage=1;
    this.restoreCache();
    this.engine.setRecords([...this.records.values()]);
    this.events=new AbortController();
    const listen=(element,event,callback)=>element?.addEventListener(event,callback,{signal:this.events.signal});
    listen(this.input,'compositionstart',()=>{this.composing=true;});
    listen(this.input,'compositionend',()=>{this.composing=false;this.schedule();});
    listen(this.input,'input',()=>{if(!this.composing)this.schedule();});
    listen(this.input,'focus',()=>this.load(true));
    listen(this.querySelector('form'),'submit',event=>{event.preventDefault();clearTimeout(this.timer);this.updateQuery();this.resultTitle.focus({preventScroll:true});});
    listen(this.reset,'click',()=>{this.input.value='';this.query='';this.active.clear();this.syncChips();this.render();this.input.focus();});
    listen(this.retry,'click',()=>{this.error=false;this.retry.hidden=true;this.load(true);});
    for(const button of this.chipButtons) listen(button,'click',()=>{
      const id=button.dataset.dwChip;
      if(this.active.has(id))this.active.delete(id);
      else {
        const chip=this.config.chips.find(chip=>chip.id===id);
        if(chip?.mode==='newest'||chip?.mode==='best') for(const active of [...this.active]) {
          const other=this.config.chips.find(chip=>chip.id===active);
          if(other?.mode==='newest'||other?.mode==='best')this.active.delete(active);
        }
        this.active.add(id);
      }
      this.syncChips();this.render();this.load(true);
    });
    for(const button of this.querySelectorAll('[data-dw-scroll]')) listen(button,'click',()=>{
      const direction=Number(button.dataset.dwScroll);
      const step=(this.list.firstElementChild?.getBoundingClientRect().width||240)+20;
      this.list.scrollBy({left:direction*step,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
    });
    listen(this.list,'scroll',()=>this.syncArrows());
    if(typeof ResizeObserver!=='undefined') {this.resizeObserver=new ResizeObserver(()=>this.syncArrows());this.resizeObserver.observe(this.list);}
    for(const control of this.querySelectorAll('[data-dw-enhance]'))control.hidden=false;
    this.render();
    if(!this.complete && typeof IntersectionObserver!=='undefined') {
      this.intersection=new IntersectionObserver(entries=>{if(entries.some(entry=>entry.isIntersecting)){this.intersection.disconnect();this.load(false);}},{rootMargin:'200px'});
      this.intersection.observe(this);
    }
  }

  restoreCache() {
    let saved=discoveryMemory.get(this.cacheKey);
    if(!saved) {try{saved=JSON.parse(sessionStorage.getItem(this.cacheKey)||'null');}catch{}}
    if(!saved||Date.now()-saved.savedAt>300000||saved.contextKey!==this.config.contextKey||!Array.isArray(saved.records))return;
    this.records=new Map(saved.records.map(record=>[String(record.id),record]));
    this.complete=saved.complete===true;this.nextPage=saved.nextPage||1;
  }

  saveCache() {
    if(this.config.source==='selection')return;
    const saved={contextKey:this.config.contextKey,records:[...this.records.values()],complete:this.complete,nextPage:this.nextPage,savedAt:Date.now()};
    discoveryMemory.set(this.cacheKey,saved);
    if(discoveryMemory.size>8)discoveryMemory.delete(discoveryMemory.keys().next().value);
    try{sessionStorage.setItem(this.cacheKey,JSON.stringify(saved));}catch{}
  }

  schedule() {
    clearTimeout(this.timer);this.timer=setTimeout(()=>this.updateQuery(),200);
  }

  updateQuery() {
    this.query=this.input.value.trim().slice(0,200);this.render();
    if(normalize(this.query).length>=2)this.load(true);
  }

  syncChips() {
    for(const button of this.chipButtons)button.setAttribute('aria-pressed',String(this.active.has(button.dataset.dwChip)));
  }

  async load(all) {
    if(this.complete||this.config.source==='selection'||!this.config.collectionUrl)return;
    this.more=this.more||all;
    if(this.loading)return;
    this.loading=true;this.error=false;this.request=new AbortController();this.render();
    try {
      do {
        const url=new URL(this.config.collectionUrl,location.origin);
        if(url.origin!==location.origin)throw new Error('Invalid collection origin');
        url.searchParams.set('section_id','dw-discovery-index');
        url.searchParams.set('sort_by','best-selling');
        url.searchParams.set('page',String(this.nextPage));
        const timeout=setTimeout(()=>this.request.abort(),12000);
        let html;
        try {
          const response=await fetch(url,{signal:this.request.signal,credentials:'same-origin',headers:{'X-Requested-With':'XMLHttpRequest'}});
          if(!response.ok)throw new Error('Collection unavailable');
          html=await response.text();
        } finally {clearTimeout(timeout);}
        const documentBody=new DOMParser().parseFromString(html,'text/html');
        const json=documentBody.querySelector('[data-dw-index]');
        if(!json)throw new Error('Collection data unavailable');
        const data=JSON.parse(json.textContent);
        if(String(data.collectionId)!==String(this.config.collectionId)||Number(data.page)!==this.nextPage||!Array.isArray(data.products))throw new Error('Collection context mismatch');
        if(this.nextPage===1) {
          const featured=new Set((this.config.featuredIds||[]).map(String));
          this.records=new Map(this.seed.filter(record=>featured.has(String(record.id))).map(record=>[String(record.id),{...record,contextKey:this.config.contextKey}]));
        }
        for(let i=0;i<data.products.length;i++) {
          const record={...data.products[i],contextKey:this.config.contextKey,bestRank:Number(data.offset)+i};
          this.records.set(String(record.id),record);
        }
        this.complete=!data.hasNext;
        this.nextPage=Number(data.page)+1;
        this.engine.setRecords([...this.records.values()]);this.saveCache();this.render();
        if(!data.products.length&&!this.complete)throw new Error('Empty collection page');
      } while(this.more&&!this.complete&&this.isConnected);
    } catch(error) {
      if(this.isConnected){this.error=true;this.retry.hidden=false;}
    } finally {
      this.loading=false;if(this.isConnected)this.render();
    }
  }

  formatBudget(budget) {
    const money=number=>this.money.format(number/100);
    if(budget.kind==='under')return this.i18n.priceUnder.replace('[amount]',money(budget.target));
    if(budget.kind==='max')return this.i18n.priceMax.replace('[amount]',money(budget.max));
    return this.i18n.priceRange.replace('[min]',money(budget.min)).replace('[max]',money(budget.max));
  }

  card(record) {
    const card=this.template.content.firstElementChild.cloneNode(true);
    const link=card.querySelector('a');
    const url=new URL(record.url,location.origin);
    if(url.origin!==location.origin||!url.pathname.includes('/products/'))return null;
    if(record.matchedOffer?.id)url.searchParams.set('variant',String(record.matchedOffer.id));
    link.href=url.pathname+url.search;
    card.querySelector('[data-card-title]').textContent=record.title;
    card.querySelector('[data-card-brand]').textContent=record.brand;
    const image=card.querySelector('[data-card-image]');
    if(record.image) {
      const imageUrl=new URL(record.image,location.origin);
      if(['https:','http:'].includes(imageUrl.protocol)){image.src=imageUrl.href;image.alt=record.title;image.sizes='(min-width: 990px) 22vw, (min-width: 750px) 30vw, 47vw';if(record.srcset)image.srcset=record.srcset;}
    } else image.remove();
    const badge=card.querySelector('[data-card-badge]');
    const badgeText=record.available?record.badge:this.i18n.soldOut;
    badge.textContent=badgeText||'';badge.hidden=!badgeText;
    const chosen=record.matchedOffer;
    card.querySelector('[data-card-meta]').textContent=chosen?.label&&chosen.label!=='Default Title'?chosen.label:record.meta;
    const price=card.querySelector('[data-card-price]');
    price.replaceChildren();
    if(record.priceVaries&&!chosen){const from=document.createElement('small');from.textContent=this.i18n.from+' ';price.append(from);}
    price.append(document.createTextNode(chosen?this.money.format(chosen.price/100):record.priceText));
    card.dataset.productId=String(record.id);
    return card;
  }

  render() {
    if(!this.engine)return;
    const chips=this.config.chips.filter(chip=>this.active.has(chip.id));
    const result=this.engine.search(this.query,chips,this.config.limit);
    const titles={featured:this.config.initialHeading,matches:this.i18n.matches,partial:this.i18n.matches,suggestions:this.i18n.inspiration,empty:this.i18n.matches};
    this.resultTitle.textContent=titles[result.kind];
    const renderKey=JSON.stringify(result.items.map(record=>[record.id,record.matchedOffer,record.priceText,record.available]));
    const intentKey=JSON.stringify([this.query,[...this.active]]);
    if(this.renderKey!==renderKey) {
      const focused=this.list.contains(document.activeElement)?document.activeElement.closest('[data-product-id]')?.dataset.productId:null;
      const oldScroll=this.list.scrollLeft;
      const fragments=document.createDocumentFragment();
      for(const record of result.items){const card=this.card(record);if(card){const li=document.createElement('li');li.append(card);fragments.append(li);}}
      this.list.replaceChildren(fragments);
      if(focused) [...this.list.querySelectorAll('[data-product-id]')].find(card=>card.dataset.productId===focused)?.querySelector('a')?.focus({preventScroll:true});
      this.list.scrollLeft=this.intentKey===intentKey?oldScroll:0;
      this.renderKey=renderKey;
    } else if(this.intentKey!==intentKey)this.list.scrollLeft=0;
    this.intentKey=intentKey;
    const active=result.query.hasQuery||chips.length>0;
    this.reset.hidden=!active;
    this.budgetLabel.hidden=!result.query.budget;
    this.budgetLabel.textContent=result.query.budget?this.formatBudget(result.query.budget):'';
    const pending=active&&!this.complete&&!this.error;
    let message='';
    if(this.error)message=this.i18n.unavailable;
    else if(pending)message=this.i18n.lookingFurther;
    else if(result.kind==='partial')message=this.config.partialMessage;
    else if(result.kind==='suggestions')message=this.config.emptyMessage;
    else if(result.kind==='empty')message=result.query.budget?this.i18n.noBudget:this.config.emptyMessage;
    this.message.textContent=message;this.message.hidden=!message;
    this.status.textContent=(this.loading&&active?this.i18n.loading+' ': '')+(result.items.length?this.i18n.shown.replace('[count]',String(result.items.length)):this.i18n.noSelection);
    this.retry.hidden=!this.error;
    this.setAttribute('aria-busy',String(this.loading));
    this.syncArrows();
  }

  syncArrows() {
    const previous=this.querySelector('[data-dw-scroll="-1"]'),next=this.querySelector('[data-dw-scroll="1"]');
    if(!previous||!next)return;
    previous.disabled=this.list.scrollLeft<2;
    next.disabled=this.list.scrollWidth-this.list.clientWidth-this.list.scrollLeft<3;
  }

  disconnectedCallback() {
    clearTimeout(this.timer);this.request?.abort();this.events?.abort();this.intersection?.disconnect();this.resizeObserver?.disconnect();
    document.removeEventListener('DOMContentLoaded',this.onReady);this.mounted=false;
  }
}

if(!customElements.get('dw-discovery'))customElements.define('dw-discovery',DrankwereldDiscovery);

})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dw-product-tools"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('dw-product-tools'))customElements.define('dw-product-tools',class extends HTMLElement{
connectedCallback(){
this.ready=()=>this.mount();
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',this.ready,{once:true});else this.mount();
}
mount(){
const id=this.dataset.section;
this.form=document.getElementById('product-form-'+id);
this.original=this.form?.querySelector('[name="add"]');
this.bar=this.querySelector('.dw-sticky-buy');this.button=this.querySelector('[data-dw-sticky-button]');
if(!this.original||!this.bar||!this.button)return;
this.sync=()=>{this.button.disabled=this.original.disabled||this.original.classList.contains('loading');const label=this.original.querySelector('span');if(label)this.button.textContent=label.textContent.trim();const priceRoot=document.getElementById('price-'+id);const price=priceRoot?.querySelector(priceRoot.querySelector('.price--on-sale')?'.price-item--sale':'.price-item--regular');if(price)this.querySelector('[data-dw-sticky-price]').textContent=price.textContent.trim();};
this.button.addEventListener('click',()=>{if(this.original.disabled)return;this.form.scrollIntoView({block:'center',behavior:'smooth'});this.original.click();});
this.observer=new MutationObserver(this.sync);this.observer.observe(this.original,{subtree:true,attributes:true,childList:true,characterData:true});
const price=document.getElementById('price-'+id);if(price)this.observer.observe(price,{subtree:true,childList:true,characterData:true});
this.intersection=new IntersectionObserver(es=>{for(const e of es)this.bar.hidden=e.isIntersecting||e.boundingClientRect.bottom>0;},{threshold:0});this.intersection.observe(this.original);
if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined')this.unsubscribe=subscribe(PUB_SUB_EVENTS.variantChange,event=>{if(String(event.data.sectionId)!==id)return;const source=event.data.html?.getElementById('DwFacts-'+id);const destination=document.getElementById('DwFacts-'+id);if(source&&destination)destination.innerHTML=source.innerHTML;this.sync();});
this.sync();
}
disconnectedCallback(){document.removeEventListener('DOMContentLoaded',this.ready);this.observer?.disconnect();this.intersection?.disconnect();this.unsubscribe?.();}
});
  } catch(e) { console.error(e); }
})();

})();
